import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgendaRoutingModule } from './agenda-routing.module';

// Ajouté le 0-/03/2024 Pour "FullCalendarModule "
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgendaComponent } from './components/agenda/agenda.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ListActivityParticipantsFinanceComponent } from './components/list-activity-participants-finance/list-activity-participants-finance.component';
import { MatCardModule } from '@angular/material/card';
import { ActivityParticipantsComponent } from './components/agenda/single-activity/activity-participants.component';
import { CreateActivityInviteComponent } from './components/create-activity-invite/create-activity-invite.component';
import { QrcodeAfficheComponent } from './components/create-activity/qrcode-affiche/qrcode-affiche.component';
import { AgendaActivitesComponent } from './components/agenda-activites/agenda-activites.component';

@NgModule({
  declarations: [
    AgendaComponent,
    ListActivityParticipantsFinanceComponent,
    ActivityParticipantsComponent,
    CreateActivityInviteComponent,
    QrcodeAfficheComponent,
    AgendaActivitesComponent,
  ],
  imports: [
    CommonModule,
    AgendaRoutingModule,
    // Ajouté le 06/03/2024
    FullCalendarModule,
    SharedModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatIconModule,
    FormsModule,
    MatCardModule,
  ],
})
export class AgendaModule {}
